import { useState, useEffect, useRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from 'react-toastify';
import { withRFSToken } from '../../../Services/axios.js';
import { SLOTPLANNINGMETADATA, SLOTPLANNINGWAREHOUSE, SLOTPLANNINGSAVESLOTSETTINGS } from '../../../Utils/conts.js';

const SlotSettings = () => {
  const isMounted = useRef(false);
  const [warehouselist, setWarehouselist] = useState([]);
  const [activeWarehouse, setActiveWarehouse] = useState(null);
  const [cargoType, setCargoType] = useState([]);
  const [slotTimeManagement, setSlotTimeManagement] = useState([]);
  const [isEditable, setIsEditable] = useState(null);
  const [formData, setFormData] = useState({
    warehouse_id: '',
    booking_cut_time: '',
    buffer_time: '',
  });

  useEffect(() => {
    if (isMounted.current) return;
    fetchWareHouseData();
    isMounted.current = true;
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const fetchMetaData = async () => {
    try {
      const res = await withRFSToken.post(SLOTPLANNINGMETADATA, { "warehouse_id": activeWarehouse });
      const cargo_type = res.data.response_data.cargo_type;
      const slot_time_management = res.data.response_data.slot_time_management;
      setCargoType(cargo_type.map(w => ({
        label: w.name,
        value: w.id
      })));
      setSlotTimeManagement(slot_time_management);
      const newFormValues = { warehouse_id: activeWarehouse };

      cargo_type.forEach(item => {
        const key = item.name.toLowerCase().replace(/\s+/g, '_');
        newFormValues[key] = item.value || '60';
      });

      slot_time_management.forEach(item => {
        newFormValues[`special_${item.id}`] = item.value || '60';
      });

      setFormData(prev => ({ ...prev, ...newFormValues }));
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  const fetchWareHouseData = async () => {
    try {
      let Handler_stn = localStorage.getItem('Handler_stn');
      if (!Handler_stn) {
        return;
      }
      Handler_stn = JSON.parse(Handler_stn);
      const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: Handler_stn.org_station_id })
      const innerData = res.data.response_data;
      setWarehouselist(innerData.map(w => ({
        label: w.name,
        value: w.id,
        doors_count: w.doors_count,
      })));
      if (innerData.length > 0) {
        setActiveWarehouse(innerData[0].id);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };

  const preparePayload = () => {
    const specialCargoData = slotTimeManagement.map(item => ({
      id: item.id,
      value: formData[`special_${item.id}`] || '60'
    }));
    const cargoTypeData = cargoType.map(item => {
      const key = item.label.toLowerCase().replace(/\s+/g, '_');
      return {
        id: item.value,
        value: formData[key] || '60'
      };
    });
    const combinedData = [...specialCargoData, ...cargoTypeData];
    const payload = {
      warehouse_id: activeWarehouse,
      metalables: combinedData
    };
    return payload;
  };

  const handleWarehouseClick = (warehouseId) => {
    setActiveWarehouse(warehouseId);
  };

  const saveSlotSettings = async () => {
    const payload = preparePayload();
    try {
      const res = await withRFSToken.post(SLOTPLANNINGSAVESLOTSETTINGS, payload)
        .then(function (res) {
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            setIsEditable(null);
          } else {
            toast.error(res.data.response_msg);
          }
        });
    } catch (error) {
      console.error('Save error:', error);
    }
  };

  useEffect(() => {
    if (activeWarehouse !== null && activeWarehouse !== undefined && activeWarehouse !== '') {
      fetchMetaData();
    }
  }, [activeWarehouse]);

  const SBack = localStorage.getItem('SettingsBack');

  return (
    // <div className="">
    //   <Header logo_url={SBack ? SBack : '/PlanningDashboard'} sBackUrl={SBack ? SBack : '/PlanningDashboard'} />
    //   <div className="main-panel">
    //     <div className="row">
    //       <LeftSettings />
    // <div className='col-9 col-xxl-9 stting_right'>
    // <div className='settingbg_right'>
    <div className='slot_setting_right'>
      <h4>Slot Setting</h4>
      <p>Manage and configure doors to add them to your system</p>
      <hr />
      <Tabs id="warehouse-tabs" activeKey={activeWarehouse} onSelect={handleWarehouseClick} className="booking_tab">
        {warehouselist?.map((warehouse) => (
          <Tab eventKey={warehouse.value} key={warehouse.value} title={<span>{warehouse.label}</span>} />
        ))}
      </Tabs>
      <div className='d-flex gap-3 flex-wrap'>
        <div className="stck_middle tw-35">
          <div className='uld_notification'>
            <div className="uld_notification_title">
              <Row className='align-items-center'>
                <Col sm="6">
                  <h3>Default Slot Duration</h3>
                </Col>
                <Col sm="6" className="text-end">
                  {isEditable === 1 ? (
                    <Button variant="primary" size="sm" onClick={() => { saveSlotSettings(); }}>Save</Button>
                  ) : (
                    <Button variant="outline-primary" size="sm" onClick={() => setIsEditable(1)}> Edit </Button>
                  )}
                </Col>
              </Row>
            </div>
            <div className="uld_notification_body">
              <Row>
                {cargoType.map((item, index) => {
                  const key = item.label.toLowerCase().replace(/\s+/g, '_');
                  return (

                    <Row className="mb-2 align-items-center" key={item.value}>
                      <Col sm="3">
                        <span>{item.label}</span>
                      </Col>
                      <Col sm="4" className="d-flex align-items-center">
                        :&nbsp;
                        <input
                          type="text"
                          name={key}
                          value={formData[key] || '60'}
                          onChange={handleInputChange}
                          className="form-control me-2"
                          disabled={isEditable !== 1}
                        />
                        <span>mins</span>
                      </Col>
                    </Row>

                  );
                })}

                {slotTimeManagement.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Row className="mb-2 align-items-center" key={item.id}>
                        <Col sm="3">
                          <span>{item.name}</span>
                        </Col>
                        <Col sm="4" className="d-flex align-items-center">
                          :&nbsp;
                          <input
                            type="text"
                            name={`special_${item.id}`}
                            value={formData[`special_${item.id}`] || '60'}
                            onChange={handleInputChange}
                            className="form-control me-2"
                            disabled={isEditable !== 1}
                          />
                          <span>mins</span>
                        </Col>
                      </Row>
                    )
                  }
                })}

                {console.log('isEditable', isEditable)}
              </Row>
            </div>

          </div>
        </div>

        <div className="stck_middle tw-35">
          <div className='uld_notification'>
            <div className="uld_notification_title">
              <Row className='align-items-center'>
                <Col sm="6">
                  <h3>Arrival Window Timeslot</h3>
                </Col>
                <Col sm="6" className="text-end">
                  {isEditable === 2 ? (
                    <Button variant="primary" size="sm" onClick={() => { saveSlotSettings(); }}>Save</Button>
                  ) : (
                    <Button variant="outline-primary" size="sm" onClick={() => setIsEditable(2)}> Edit </Button>
                  )}
                </Col>
              </Row>
            </div>
            <div className="uld_notification_body">
              {slotTimeManagement.map((item, index) => {
                if ([205, 206].includes(item.id)) {
                  return (
                    <>

                      <Row key={item.id} className='mb-2'>
                        <span className='mb-2'>{item.name}</span>
                        <Col sm="3" className="d-flex align-items-center w-100">
                          <input
                            type="text"
                            name={`special_${item.id}`}
                            value={formData[`special_${item.id}`] || '60'}
                            onChange={handleInputChange}
                            className="form-control me-2 tw-25"
                            disabled={isEditable !== 2}
                          />
                          <span>Min</span>
                        </Col>
                      </Row>

                    </>
                  )
                }
              })}
            </div>
          </div>
        </div>

        <div className="stck_middle tw-35">
          <div className='uld_notification'>
            <div className="uld_notification_title">
              <Row className='align-items-center'>
                <Col sm="6">
                  <h3>Slot Request Window</h3>
                </Col>
                <Col sm="6" className="text-end">
                  {isEditable === 3 ? (
                    <Button variant="primary" size="sm" onClick={() => { saveSlotSettings(); }}>Save</Button>
                  ) : (
                    <Button variant="outline-primary" size="sm" onClick={() => setIsEditable(3)}> Edit </Button>
                  )}
                </Col>
              </Row>
            </div>
            <div className="uld_notification_body">
              {slotTimeManagement.map((item, index) => {
                if ([18, 204].includes(item.id)) {
                  return (
                    <>
                      <Row key={item.id} className='mb-2'>
                        <span className='mb-2'>{item.name}</span>
                        <Col sm="3" className="d-flex align-items-center w-100">
                          <input
                            type="text"
                            name={`special_${item.id}`}
                            value={formData[`special_${item.id}`] || '60'}
                            onChange={handleInputChange}
                            className="form-control me-2 tw-25"
                            disabled={isEditable !== 3}
                          />
                          <span>Hours</span>
                        </Col>
                      </Row>
                    </>
                  )
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
    //     </div>
    //   </div>
    // </div>
  )
}

export default SlotSettings;
